// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCookie } from "@insite/mobius/utilities/cookies";

export const isInVmi = (): boolean => {
    return (getCookie("NavigationMode") || "Storefront") === "Vmi";
};

export function getVmiSettings(state: ApplicationState) {
    const settings = getSettingsCollection(state).brsSettings;
    return {
        hideExtendedPrices: isInVmi() && (settings.vmiHideExtendedPrices ?? false),
        hideOrderSummaryData: isInVmi() && (settings.vmiHideOrderSummaryData ?? false),
        hideCart: isInVmi() && (settings.vmiHideCart ?? false),
    };
}
